import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";

export const ROLLUP_STATUS_QUERY = gql`
  query RollupStatus {
    chainRollupStatuses {
      id
      id_blockchain
      name
      short_name
      status_archive
      status_non_archive
      status_historical
    }
  }
`;

export const STATUS_QUERY = gql`
  query CurrentStatus {
    current {
      resources {
        id
        name
        chainId
        current
        block
        error
      }
    }
  }
`;

export const RESOURCE_QUERY = gql`
  query Resource($id: String) {
    resource(id: $id) {
      id
      name
      chainId
      current
      block
      error
      history {
        date
        block
        current
        error
      }
      postgres {
        tables {
          relname
          rows_in_bytes
          num_rows
          number_of_indexes
          unique
          single_column
          multi_column
        }
      }
    }
  }
`;

export const NEW_BLOCK_SUBSCRIPTION = gql`
  subscription NewBlock {
    newBlock {
      id
      name
      chainId
      current
      block
      error
    }
  }
`;

export function useSubscribeToMore() {
  const { subscribeToMore } = useQuery(STATUS_QUERY);

  useEffect(() => {
    return subscribeToMore({
      document: NEW_BLOCK_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        console.log("New Block", subscriptionData?.data?.newBlock?.name);
        const resources = (prev?.current?.resources ?? []).map(
          (resource: any) => {
            if (subscriptionData?.data?.newBlock?.id === resource?.id) {
              return subscriptionData.data.newBlock;
            }
            return resource;
          }
        );
        return {
          ...prev,
          current: {
            ...prev?.current,
            resources,
          },
        };
      },
    });
  }, []);

  return null;
}
